import React from 'react'
import button from "../assets/button.png"
import button2 from "../assets/button2.png"
// import Timeline from './TimelineItem';
import topbird from "../assets/topbird.gif"
import timeline from "../assets/timeline.png"
import chart from "../assets/chart.png";

const PreSale = () => {
    return (
        <>
         <div className='h-full md:w-[1442px] w-full flex items-center justify-center flex-col'>
            <section className='bg-black pb-5 flex justify-center md:flex-row flex-col'>
                <article className='md:w-[50%] w-full flex px-10 mt-10 flex-col'>
                    <h1 className='md:text-[5rem] text-[#0052FF] text-[3rem]'>$FLAPPY</h1>
                    <h1 className='md:text-[5rem] text-[3rem]'>Pre-Sale</h1>
                    <p className='text-[#E4E4E4] md:w-[80%] mt-3'>Flappy Base App is powered its native token $FLAPPY, which is currently under Pre-Sale.</p>
                    <div className='flex items-center mt-5 w-full md:ml-[1%] ml-[10%]'>
                        <a href='/'>
                            <img src={button} alt='' className='h-[60%] w-[60%]' />
                        </a>
                        <a href='/' className='relative -ml-10'>
                            <img src={button2} alt='' className='h-[60%] w-[60%]' />
                            <span className='absolute left-[3%] top-[10%]'>Tokenomics</span>
                        </a>
                    </div>
                    <div className='md:w-[50%] mt-5 w-full flex items-center justify-center relative'>
                     
                   <img src={chart} alt="" className='scale-150'/>
</div>
                </article>
                <section className='md:w-[50%] w-full flex items-center justify-center flex-col relative'>
                <img src={topbird} alt="" className='h-16 w-16 absolute top-[35%] left-10'/>
                <img src={timeline} alt='' className='h-[80%]'/>
{/* <Timeline /> */}
                </section>
            </section>
            </div>
        </>
    )
}

export default PreSale
